import { InfraTicketDescriptionDialogState } from ".";

export const InfraTicketDescriptionDialogInitialState: InfraTicketDescriptionDialogState =
  {
    isShow: false,
    tcktDesc: undefined,
  };
